import { Controller } from 'react-hook-form'
import {
  Box,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
} from '@material-ui/core'

import { Card, Label, Select as SelectComponent } from 'components'
import constants from 'constants/index'
import helpers from 'helpers'

const GeneralInformation = ({ control, errors }) => {
  return (
    <Card title="Informações básicas">
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <Controller
            as={
              <TextField
                label="Nome"
                fullWidth
                variant="outlined"
                error={!!errors.name}
                helperText={errors?.name?.message}
              />
            }
            name="name"
            control={control}
            mode="onBlur"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Controller
            as={
              <TextField
                label="Valor sugerido"
                fullWidth
                variant="outlined"
                error={!!errors.price}
                helperText={errors?.price?.message}
                InputProps={{ startAdornment: <Box mr={0.5}>R$</Box> }}
              />
            }
            name="price"
            control={control}
            onChange={([event]) =>
              helpers.formatters.currencyInput(event.target.value)
            }
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            as={
              <TextField
                label="Descrição"
                fullWidth
                multiline
                minRows={5}
                maxRows={5}
                variant="outlined"
                error={!!errors.description}
                helperText={errors?.description?.message}
              />
            }
            name="description"
            control={control}
            mode="onBlur"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Label title="Prazo padrão">
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Controller
                  as={
                    <TextField
                      label="Valor do prazo"
                      type="number"
                      fullWidth
                      variant="outlined"
                      error={!!errors.recommendedDeadlineValue}
                      helperText={errors?.recommendedDeadlineValue?.message}
                    />
                  }
                  name="recommendedDeadlineValue"
                  control={control}
                  mode="onBlur"
                  type="number"
                />
              </Grid>
              <Grid item xs={6}>
                <Controller
                  as={
                    <SelectComponent
                      label="Período do prazo"
                      items={constants.paymentServiceTemplate.PERIOD_OPTIONS}
                      error={!!errors.recommendedDeadlinePeriod}
                      helperText={errors?.recommendedDeadlinePeriod?.message}
                    />
                  }
                  name="recommendedDeadlinePeriod"
                  control={control}
                  mode="onBlur"
                />
              </Grid>
            </Grid>
          </Label>
        </Grid>
        <Grid item xs={12} md={6}>
          <Grid item xs={12} md={6}>
            <FormControlLabel
              control={
                <Controller
                  as={<Switch color="primary" />}
                  name="renewable"
                  control={control}
                  onChange={([event]) => event.target.checked}
                />
              }
              label="Sugerir renovação automática"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Box display="flex" alignItems="center" height="100%">
              <FormControlLabel
                control={
                  <Controller
                    as={<Switch color="primary" />}
                    name="active"
                    control={control}
                    onChange={([event]) => event.target.checked}
                  />
                }
                label="Ativo"
              />
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  )
}

export default GeneralInformation
